import { render, staticRenderFns } from "./SpacingLarge.vue?vue&type=template&id=5206385d"
import script from "./SpacingLarge.vue?vue&type=script&lang=js"
export * from "./SpacingLarge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports